var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select-animation"},[_c('div',{staticClass:"block"}),_vm._v(" "),_c('div',{staticClass:"preview"}),_vm._v(" "),_c('modal-window',{attrs:{"visible":_vm.isShow},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }